import Vue from "vue";
import API from "@/repositories/api";
Vue.prototype.$axios = API;
export default Vue.prototype.$axios;
